import { Box, Typography } from '@mui/material';
import { useUserDateRenderer } from '@issuemanager/apps/client/hooks';
import { useAtlasSemanticThemeTokens } from '@issuemanager/apps/client/theme';
import { DayjsValue } from '@issuemanager/apps/client/utils';

type Props = {
  date?: DayjsValue;
};

export function DateWithTime({ date }: Props) {
  const semantic = useAtlasSemanticThemeTokens();
  const { getValues } = useUserDateRenderer();
  const { date: formattedDate, time: formattedTime } = getValues(date);

  return (
    <Box alignItems='center' data-value={date}>
      <Typography textAlign='left' lineHeight='20px'>
        {formattedDate}
      </Typography>
      <Typography
        fontSize={12}
        textAlign='left'
        lineHeight='14px'
        color={semantic.color.text.muted}
      >
        {formattedTime}
      </Typography>
    </Box>
  );
}
